export default {
  label: 'Component type',
  items: {
    line: 'Line',
    stackedLine: 'Stacked Line',
    column: 'Column',
    stackedColumn: 'Stacked Column',
    bar: 'Bar',
    stackedBar: 'Stacked Bar',
    donut: 'Donut',
    number: 'Number',
  },
};
